// extracted by mini-css-extract-plugin
export default {"loadingApp":"AppLoginWaiting__loadingApp--SGUyEus","loaded":"AppLoginWaiting__loaded--CER3Fga","bar":"AppLoginWaiting__bar--MhYqlH3"};